import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { environment } from '../environments/environment';
import { provideApi } from './api/provide-api';
import { routes } from './app.routes';
import { apiUrlInterceptor } from './interceptors/api-url.interceptor';
import { authTokenInterceptor } from './interceptors/auth-token.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideAnimations(),
        provideApi(environment.basePath.replace(/\/api\/?$/, '')),
        provideHttpClient(
            withInterceptors([
                apiUrlInterceptor,      // First: prepend base API URL
                authTokenInterceptor,   // Second: add Bearer token
                errorInterceptor        // Last: handle errors
            ])
        )
    ]
};
